import { useMutation } from '@tanstack/react-query'
import { runRegression } from '../api/regressionApi'

export function useRunRegression() {
  return useMutation({
    mutationFn: runRegression,
  })
}